import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, signal } from '@angular/core';

@Component({
    selector: 'app-lazy-load-error-modal',
    templateUrl: './lazy-load-error-modal.component.html',
    styleUrls: ['./lazy-load-error-modal.component.css'],
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LazyLoadErrorModalComponent {
  opened = signal(false);

  open() {
    this.opened.set(true);
  }

  reloadPage(): void {
    window.location.reload();
  }
}
